import lazyImporter from '@/utils/lazyImporter'

const postTypeRoute = {
  component: lazyImporter('View'),
  meta: { title: 'postTypes', icon: 'event', hidden: true },
  name: 'admin_post_type',
  path: '/post-type',
  redirect: { name: 'admin_post_type_list' },
  children: [
    {
      component: lazyImporter('postType/PostTypeList'),
      meta: { title: 'postTypesList', hidden: true },
      name: 'admin_post_type_list',
      path: ''
    },
    {
      component: lazyImporter('postType/PostTypeUpdate'),
      meta: { title: 'postTypeUpdate', hidden: true },
      name: 'admin_post_type_update',
      path: ':slug/update',
      props: true
    },
    {
      component: lazyImporter('postType/PostTypeAdd'),
      meta: { title: 'postTypeAdd', hidden: true },
      name: 'admin_post_type_add',
      path: 'add'
    }
  ]
}

export default postTypeRoute
